import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  sections: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-12'],
    alignSelf: 'flex-start',
    width: '100%',
  },
  section: {
    display: 'flex',
    padding: '16px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'flex-start',
    width: '859px',
    border: `1px solid ${colors.tertiaryBorder}`,
    borderRadius: anatomy.borderRadiusS,
    backgroundColor: colors.ghostBackground,
  },
  sectionTitle: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeBody-4'],
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightBody-4'],
    margin: 0,
  },
  mainGuestFields: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '20px',
  },
  fieldRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    columnGap: '12px',
    rowGap: '20px',
    alignSelf: 'stretch',
  },
  fieldLabel: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeBody-5'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-5'],
    marginBottom: '2px',
  },
  fieldWithLabel: {
    display: 'flex',
    flexDirection: 'column',
  },
  fieldRowColumnGap20: {
    columnGap: '20px',
  },
  sectionExtraGuests: {
    gap: anatomy['space-8'],
    backgroundColor: colors.brandGhostBackground,
    width: '859px',
    borderRadius: anatomy.borderRadiusS,
  },
  extraGuestsContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-20'],
    alignSelf: 'stretch',
    width: '100%',
  },
  extraGuestsContentNoGap: {
    gap: 0,
  },
  addGuestButtons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: anatomy['space-16'],
    alignSelf: 'flex-start',
  },
  sectionDeliveryMethod: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-12'],
    alignSelf: 'flex-start',
    width: '100%',
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
  },
  deliveryMethodOptions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-12'],
    alignSelf: 'stretch',
  },
  deliveryMethodOption: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-8'],
    cursor: 'pointer',
  },
  radioInput: {
    width: '16px',
    height: '16px',
    flexShrink: 0,
    cursor: 'pointer',
    appearance: 'none',
    border: `1px solid ${colors.ghostIcon}`,
    borderRadius: '100%',
    margin: 0,
    backgroundColor: colors.primaryBackground,
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    position: 'relative',
    '::after': {
      content: '""',
      width: '11px',
      height: '11px',
      borderRadius: '100%',
      display: 'block',
      position: 'absolute',
      margin: 0,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    ':checked': {
      borderColor: colors.accentBorder,
      backgroundColor: colors.primaryBackground,
    },
    ':checked::after': {
      boxShadow: `inset 0 0 0 6px ${colors.accentBackground}`,
    },
  },

  adultContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-20'],
    alignSelf: 'stretch',
    fontFamily: fonts.din2014Regular,
  },
  adultCont: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-24'],
    alignSelf: 'stretch',
  },
  adultCont1: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
  },
  adultTitle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
  },
  adultTitleText: {
    color: colors.secondaryBackground,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    lineHeight: typography['lineHeightCaption-1'],
    marginBottom: '4px',
  },
  adultInputContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: anatomy['space-12'],
    alignSelf: 'stretch',
  },
  adultInputContent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: anatomy['space-20'],
    flex: '1 0 0',
  },
  adultInputContentCard: {
    display: 'flex',
    paddingBottom: '10px',
    alignItems: 'center',
    gap: anatomy['space-10'],
  },
  iconContainer: {
    display: 'flex',
    color: colors.ghostIcon,
    ':not(#__unused__) > button': {
      color: 'inherit',
    },
    ':hover': {
      color: colors.accentIcon,
    },
  },

  radioLabel: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    margin: 0,
    cursor: 'pointer',
  },
  radioError: {
    fontFamily: fonts.din2014Regular,
    fontSize: '12px',
    lineHeight: '16px',
    color: colors.errorText,
    marginBottom: '4px',
  },
  radioGroupError: {
    ':not(#__unused__) input[type="radio"]': {
      borderColor: colors.errorBorder,
    },
  },
  radioErrorContainer: {
    display: 'flex',
    gap: anatomy['space-8'],
    alignItems: 'center',
    padding: `${anatomy['space-8']} ${anatomy['space-16']}`,
    background: colors.errorBackground,
    borderRadius: anatomy.borderRadiusS,
  },
  radioErrorText: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.errorText,
  },
});
